// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"a61d2445","556":"5ea1743e","779":"55d59e4c"}[chunkId] + ".chunk.css";
};